import { motion } from "framer-motion";
import { useWindowSize } from 'react-use';
import { Link } from 'react-router-dom';
import { useSettings } from "../../../app/context/settings-context/settings-context";


import './product-card.css';

import food from "../../../assets/images/icons/food.svg";
function strpos_px(str,width,font_size_px){
    const KOEF1=0.500604
    let tmp_pos=width/(KOEF1*font_size_px)
    if(tmp_pos>str.lenth-2) return tmp_pos
    const tmp_str=str.substring(0,tmp_pos)
    let pos=tmp_str.lastIndexOf(' ')
    if(pos===-1) pos=tmp_pos
    return pos
}


export const ProductCard = ({children, props}) => {

    const {width} = useWindowSize();

    const {hasPayments} = useSettings();

    const animation = {
        hidden: { opacity: 0, y: -100 },
        show: {
          opacity: 1,
          y: 0,
          transition: {
            staggerChildren: 0.7,
            duration: 0.3,
            type: 'tween',
            ease: 'easeInOut'
          }
        }
      };

    const description=props.description || '';

    // const cardWidth = width - 145;
    
    // const pos=strpos_px(description, cardWidth*2, 12)
    // let description1 = description.substring(0,pos);
    // let description2 = description.substring(pos);
     
    return (
        <motion.div
            
            variants={animation}
            initial="hidden"
            animate="show"
        >
                <Link to={`/product/${props.id}`} className={`product-card position-relative col-12 mb-1 py-2 border-bottom`}>
                    <div className="d-flex">
                        <div className="product-image">
                            { props.img ?
                                <img src={props.img} alt={props.name} /> :
                                <img className="default-img" src={food} alt="aboba" />
                            }
                        </div>
                        <div className="w-100">
                           <div className="row ms-0">
                                <div className="product-head d-flex justify-content-between">
                                    <div className="product-title pe-2"><span>{props.name}</span></div>
                                    <div className="product-price text-end"><span>{props.price}</span></div>
                                </div>
                           </div>
                            <div className="row ms-0 justify-content-between">
                                <div className="col col-md-10 pe-0">
                                    <div className="product-description">
                                        <span>
                                            {description}
                                        </span>
                                    </div>
                                </div>
                               <div className="col-5 w-auto ms-1 col-md-2 ps-0 ">
                                    <div className="d-flex flex-column justify-content-between align-items-end">
                                            {children && hasPayments() &&
                                                children 
                                            }
                                    </div>
                               </div>
                            </div>
                        </div>
                    </div>
                </Link>
        </motion.div>
     )
}
